import { ConsolePluginFacade } from '../../JWeb/facades/ConsolePluginFacade';
import { GenericLogMethod, LevelLogProps } from '../types';
import { getNativeLogLevel } from './getNativeLogLevel';

export interface SystemLogMethodArgs {
  params: string[];
  loggerProps: LevelLogProps;
  [key: string]: any;
}

/**
 * Creates a log method that ALWAYS emits, bypassing all enable/disable controls.
 *
 * Output is always directed to the native logger (as LogLevel.Log) and/or
 * the browser console via console.log, based on the transport flags set
 * at construction time (shouldCallNativeLog / shouldCallBrowserLog).
 */
export function systemLogMethod({
  params: paramsName,
  loggerProps,
  ...defaultValues
}: SystemLogMethodArgs): GenericLogMethod {
  const { shouldCallBrowserLog, shouldCallNativeLog } = loggerProps;

  const defaultParamsList: Record<string, any> = {};
  paramsName.forEach((param) => {
    if (defaultValues[param] !== undefined) {
      defaultParamsList[param] = defaultValues[param];
    }
  });

  const errorReplacer = (_key: string, value: unknown) => {
    if (value instanceof Error) {
      return { name: value.name, message: value.message, stack: value.stack };
    }
    return value;
  };

  return function (...userParamsValues: any[]) {
    const timestamp = new Date().toISOString();
    const runtimeParamList: Record<string, any> = {};
    const customUserParams = userParamsValues;

    customUserParams.forEach((paramObj) => {
      paramsName.forEach((param) => {
        if (paramObj && paramObj[param] !== undefined) {
          runtimeParamList[param] = paramObj[param];
          if (!(paramObj instanceof Error)) {
            delete paramObj[param];
          }
        }
      });
    });

    const log = {
      timestamp,
      ...defaultParamsList,
      ...runtimeParamList,
      data: customUserParams
    };

    if (shouldCallNativeLog) {
      const message = JSON.stringify(log, errorReplacer);
      ConsolePluginFacade.getConsolePlugin()?.log?.({
        logLevel: getNativeLogLevel('log'),
        message,
        tag: ''
      });
    }

    if (shouldCallBrowserLog) {
      console.log('[SYSTEM]', log);
    }
  };
}
